module.exports = __webpack_public_path__ + "img/pecans-bg-portrait-576w.13fa502e.jpg";